import api from '../../api';
import Logger from '../../../lib/Logger';

import { schema } from '../../schema';
import { addEntities, removeEntity } from '../../actions';
import { normalize } from 'normalizr';

export const TYPES = {
  MODULE_SERIE_ADMIN_LIST_REQUEST:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_LIST_REQUEST',
  MODULE_SERIE_ADMIN_LIST_SUCCESS:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_LIST_SUCCESS',
  MODULE_SERIE_ADMIN_LIST_FAILURE:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_LIST_FAILURE',
  MODULE_SERIE_ADMIN_CREATE_REQUEST:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_CREATE_REQUEST',
  MODULE_SERIE_ADMIN_CREATE_SUCCESS:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_CREATE_SUCCESS',
  MODULE_SERIE_ADMIN_CREATE_FAILURE:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_CREATE_FAILURE',
  MODULE_SERIE_ADMIN_UPDATE_REQUEST:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_UPDATE_REQUEST',
  MODULE_SERIE_ADMIN_UPDATE_SUCCESS:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_UPDATE_SUCCESS',
  MODULE_SERIE_ADMIN_UPDATE_FAILURE:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_UPDATE_FAILURE',
  MODULE_SERIE_ADMIN_PATCH_REQUEST:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_PATCH_REQUEST',
  MODULE_SERIE_ADMIN_PATCH_SUCCESS:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_PATCH_SUCCESS',
  MODULE_SERIE_ADMIN_PATCH_FAILURE:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_PATCH_FAILURE',
  MODULE_SERIE_ADMIN_READ_REQUEST:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_READ_REQUEST',
  MODULE_SERIE_ADMIN_READ_SUCCESS:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_READ_SUCCESS',
  MODULE_SERIE_ADMIN_READ_FAILURE:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_READ_FAILURE',
  MODULE_SERIE_ADMIN_IDS_REQUEST:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_IDS_REQUEST',
  MODULE_SERIE_ADMIN_IDS_SUCCESS:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_IDS_SUCCESS',
  MODULE_SERIE_ADMIN_IDS_FAILURE:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_IDS_FAILURE',
  MODULE_SERIE_ADMIN_DELETE_REQUEST:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_DELETE_REQUEST',
  MODULE_SERIE_ADMIN_DELETE_SUCCESS:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_DELETE_SUCCESS',
  MODULE_SERIE_ADMIN_DELETE_FAILURE:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_DELETE_FAILURE',
  MODULE_SERIE_ADMIN_DELETES_REQUEST:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_DELETES_REQUEST',
  MODULE_SERIE_ADMIN_DELETES_SUCCESS:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_DELETES_SUCCESS',
  MODULE_SERIE_ADMIN_DELETES_FAILURE:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_DELETES_FAILURE',
  MODULE_SERIE_ADMIN_FORM_DESTROY:
    'LEARNING_ADMIN/MODULE_SERIE_ADMIN_FORM_DESTROY',
  MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_REQUEST:
    'LEARNING_ADMIN/MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_REQUEST',
  MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_SUCCESS:
    'LEARNING_ADMIN/MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_SUCCESS',
  MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_FAILURE:
    'LEARNING_ADMIN/MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_FAILURE',
  MODULE_ADMIN_LIST_REQUEST: 'LEARNING_ADMIN/MODULE_ADMIN_LIST_REQUEST',
  MODULE_ADMIN_LIST_SUCCESS: 'LEARNING_ADMIN/MODULE_ADMIN_LIST_SUCCESS',
  MODULE_ADMIN_LIST_FAILURE: 'LEARNING_ADMIN/MODULE_ADMIN_LIST_FAILURE',
  MODULE_ADMIN_PATCH_REQUEST: 'LEARNING_ADMIN/MODULE_ADMIN_PATCH_REQUEST',
  MODULE_ADMIN_PATCH_SUCCESS: 'LEARNING_ADMIN/MODULE_ADMIN_PATCH_SUCCESS',
  MODULE_ADMIN_PATCH_FAILURE: 'LEARNING_ADMIN/MODULE_ADMIN_PATCH_FAILURE',
  MODULE_ADMIN_IDS_REQUEST: 'LEARNING_ADMIN/MODULE_ADMIN_IDS_REQUEST',
  MODULE_ADMIN_IDS_SUCCESS: 'LEARNING_ADMIN/MODULE_ADMIN_IDS_SUCCESS',
  MODULE_ADMIN_IDS_FAILURE: 'LEARNING_ADMIN/MODULE_ADMIN_IDS_FAILURE',
  MODULE_ADMIN_DELETE_REQUEST: 'LEARNING_ADMIN/MODULE_ADMIN_DELETE_REQUEST',
  MODULE_ADMIN_DELETE_SUCCESS: 'LEARNING_ADMIN/MODULE_ADMIN_DELETE_SUCCESS',
  MODULE_ADMIN_DELETE_FAILURE: 'LEARNING_ADMIN/MODULE_ADMIN_DELETE_FAILURE',
  MODULE_ADMIN_DELETES_REQUEST: 'LEARNING_ADMIN/MODULE_ADMIN_DELETES_REQUEST',
  MODULE_ADMIN_DELETES_SUCCESS: 'LEARNING_ADMIN/MODULE_ADMIN_DELETES_SUCCESS',
  MODULE_ADMIN_DELETES_FAILURE: 'LEARNING_ADMIN/MODULE_ADMIN_DELETES_FAILURE',
  MODULES_ADMIN_CREATE_REQUEST: 'LEARNING_ADMIN/MODULES_ADMIN_CREATE_REQUEST',
  MODULES_ADMIN_CREATE_SUCCESS: 'LEARNING_ADMIN/MODULES_ADMIN_CREATE_SUCCESS',
  MODULES_ADMIN_CREATE_FAILURE: 'LEARNING_ADMIN/MODULE_ADMIN_CREATE_FAILURE',
  MODULES_ADMIN_UPDATE_REQUEST: 'LEARNING_ADMIN/MODULES_ADMIN_UPDATE_REQUEST',
  MODULES_ADMIN_UPDATE_SUCCESS: 'LEARNING_ADMIN/MODULES_ADMIN_UPDATE_SUCCESS',
  MODULES_ADMIN_UPDATE_FAILURE: 'LEARNING_ADMIN/MODULE_ADMIN_UPDATE_FAILURE',
  MODULE_CATEGORY_ADMIN_LIST_REQUEST:
    'LEARNING_ADMIN/MODULE_CATEGORY_ADMIN_LIST_REQUEST',
  MODULE_CATEGORY_ADMIN_LIST_SUCCESS:
    'LEARNING_ADMIN/MODULE_CATEGORY_ADMIN_LIST_SUCCESS',
  MODULE_CATEGORY_ADMIN_LIST_FAILURE:
    'LEARNING_ADMIN/MODULE_CATEGORY_ADMIN_LIST_FAILURE',
  MODULE_CATEGORY_ADMIN_CREATE_REQUEST:
    'LEARNING_ADMIN/MODULE_CATEGORY_ADMIN_CREATE_REQUEST',
  MODULE_CATEGORY_ADMIN_CREATE_SUCCESS:
    'LEARNING_ADMIN/MODULE_CATEGORY_ADMIN_CREATE_SUCCESS',
  MODULE_CATEGORY_ADMIN_CREATE_FAILURE:
    'LEARNING_ADMIN/MODULE_CATEGORY_ADMIN_CREATE_FAILURE',
  MODULE_CATEGORY_ADMIN_DELETE_REQUEST:
    'LEARNING_ADMIN/MODULE_CATEGORY_ADMIN_DELETE_REQUEST',
  MODULE_CATEGORY_ADMIN_DELETE_SUCCESS:
    'LEARNING_ADMIN/MODULE_CATEGORY_ADMIN_DELETE_SUCCESS',
  MODULE_CATEGORY_ADMIN_DELETE_FAILURE:
    'LEARNING_ADMIN/MODULE_CATEGORY_ADMIN_DELETE_FAILURE',
  MODULE_ADMIN_CREATE_REQUEST: 'LEARNING_ADMIN/MODULE_ADMIN_CREATE_REQUEST',
  MODULE_ADMIN_CREATE_SUCCESS: 'LEARNING_ADMIN/MODULE_ADMIN_CREATE_SUCCESS',
  MODULE_ADMIN_CREATE_FAILURE: 'LEARNING_ADMIN/MODULE_ADMIN_CREATE_FAILURE',
  MODULE_ADMIN_FORM_DESTROY: 'LEARNING_ADMIN/MODULE_ADMIN_FORM_DESTROY',
  MODULE_ADMIN_READ_REQUEST: 'LEARNING_ADMIN/MODULE_ADMIN_READ_REQUEST',
  MODULE_ADMIN_READ_SUCCESS: 'LEARNING_ADMIN/MODULE_ADMIN_READ_SUCCESS',
  MODULE_ADMIN_READ_FAILURE: 'LEARNING_ADMIN/MODULE_ADMIN_READ_FAILURE',
  MODULE_ADMIN_UPDATE_REQUEST: 'LEARNING_ADMIN/MODULE_ADMIN_UPDATE_REQUEST',
  MODULE_ADMIN_UPDATE_SUCCESS: 'LEARNING_ADMIN/MODULE_ADMIN_UPDATE_SUCCESS',
  MODULE_ADMIN_UPDATE_FAILURE: 'LEARNING_ADMIN/MODULE_ADMIN_UPDATE_FAILURE',
};

export function moduleSerieAdminFormDestroy(formState = null) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminFormDestroy(%j)`,
    formState
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_FORM_DESTROY,
    form: formState,
  };
}

export function moduleAdminFormDestroy(formState = null) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminFormDestroy(%j)`,
    formState
  );
  return {
    type: TYPES.MODULE_ADMIN_FORM_DESTROY,
    form: formState,
  };
}

export function moduleSerieAdminListRequest(
  partnershipId,
  action,
  page,
  limit,
  order,
  filter
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminListRequest(${partnershipId}, ${action}, ${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_LIST_REQUEST,
    partnershipId: partnershipId,
    action: action,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function moduleSerieAdminListSuccess(partnershipId, action, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminListSuccess(${partnershipId}, ${action}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_LIST_SUCCESS,
    partnershipId: partnershipId,
    action: action,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function moduleSerieAdminListFailure(partnershipId, action, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminListFailure(${partnershipId}, ${action} %j)`,
    error
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_LIST_FAILURE,
    partnershipId: partnershipId,
    action: action,
    error: error,
  };
}

export function moduleSerieAdminCreateRequest(data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminCreateRequest(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_CREATE_REQUEST,
  };
}

export function moduleSerieAdminCreateSuccess(data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminCreateSuccess(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_CREATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function moduleSerieAdminCreateFailure(error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminCreateFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_CREATE_FAILURE,
    error: error,
  };
}

export function moduleSerieAdminReadRequest(id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminReadRequest(${id})`
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_READ_REQUEST,
    id: id,
  };
}

export function moduleSerieAdminReadSuccess(data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminReadSuccess(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_READ_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function moduleSerieAdminReadFailure(error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminReadFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_READ_FAILURE,
    error: error,
  };
}

export function moduleSerieAdminUpdateRequest(id, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminUpdateRequest(${id}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_UPDATE_REQUEST,
  };
}

export function moduleSerieAdminUpdateSuccess(data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminUpdateSuccess(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_UPDATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function moduleSerieAdminUpdateFailure(error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminUpdateFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_UPDATE_FAILURE,
    error: error,
  };
}

export function moduleSerieAdminPatchRequest(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminPatchRequest(${partnershipId}, ${id}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_PATCH_REQUEST,
    partnershipId: partnershipId,
  };
}

export function moduleSerieAdminPatchSuccess(partnershipId, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminPatchSuccess(${partnershipId}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_PATCH_SUCCESS,
    id: data.id,
    partnershipId: partnershipId,
    receivedAt: Date.now(),
  };
}

export function moduleSerieAdminPatchFailure(partnershipId, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminPatchFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_PATCH_FAILURE,
    partnershipId: partnershipId,
    error: error,
  };
}

export function moduleSerieIdsAdminRequest(partnershipId, order) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieIdsAdminRequest(${partnershipId}, ${order})`
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_IDS_REQUEST,
    partnershipId: partnershipId,
    order: order,
  };
}

export function moduleSerieIdsAdminSuccess(partnershipId, order, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieIdsAdminSuccess(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_IDS_SUCCESS,
    data: data,
    partnershipId: partnershipId,
    order: order,
  };
}

export function moduleSerieIdsAdminFailure(partnershipId, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieIdsAdminFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_IDS_FAILURE,
    error: error,
    partnershipId: partnershipId,
  };
}

export function moduleSerieAdminDeleteRequest(id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminDeleteRequest(${id})`
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_DELETE_REQUEST,
    id: id,
  };
}

export function moduleSerieAdminDeleteSuccess(id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminDeleteSuccess(${id})`
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_DELETE_SUCCESS,
    id: id,
    receivedAt: Date.now(),
  };
}

export function moduleSerieAdminDeleteFailure(error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminDeleteFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_DELETE_FAILURE,
    error: error,
  };
}

export function moduleSerieAdminDeletesRequest(id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminDeletesRequest(${id})`
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_DELETES_REQUEST,
    id: id,
  };
}

export function moduleSerieAdminDeletesSuccess(id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminDeletesSuccess(${id})`
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_DELETES_SUCCESS,
    id: id,
    receivedAt: Date.now(),
  };
}

export function moduleSerieAdminDeletesFailure(error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminDeletesFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_SERIE_ADMIN_DELETES_FAILURE,
    error: error,
  };
}

export function moduleAdminListByModuleSerieIdRequest(
  partnershipId,
  moduleSerieId,
  page,
  limit,
  order,
  filter
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminListByModuleSerieIdRequest(${partnershipId}, ${moduleSerieId}, ${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: TYPES.MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_REQUEST,
    partnershipId: partnershipId,
    moduleSerieId: moduleSerieId,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function moduleAdminListByModuleSerieIdSuccess(
  partnershipId,
  moduleSerieId,
  data
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminListByModuleSerieIdSuccess(${partnershipId}, ${moduleSerieId}, %j)`,
    data
  );

  return {
    type: TYPES.MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_SUCCESS,
    partnershipId: partnershipId,
    moduleSerieId: moduleSerieId,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function moduleAdminListByModuleSerieIdFailure(
  partnershipId,
  moduleSerieId,
  error
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminListByModuleSerieIdFailure(${partnershipId}, ${moduleSerieId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_FAILURE,
    partnershipId: partnershipId,
    moduleSerieId: moduleSerieId,
    error: error,
  };
}

export function moduleAdminListRequest(
  partnershipId,
  page,
  limit,
  order,
  filter
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminListRequest(${partnershipId}, ${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: TYPES.MODULE_ADMIN_LIST_REQUEST,
    partnershipId: partnershipId,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function moduleAdminListSuccess(partnershipId, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminListSuccess(${partnershipId}, %j)`,
    data
  );

  return {
    type: TYPES.MODULE_ADMIN_LIST_SUCCESS,
    partnershipId: partnershipId,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function moduleAdminListFailure(partnershipId, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminListFailure(${partnershipId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_ADMIN_LIST_FAILURE,
    partnershipId: partnershipId,
    error: error,
  };
}

export function moduleAdminPatchRequest(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminPatchRequest(${partnershipId},  ${id}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_ADMIN_PATCH_REQUEST,
    partnershipId: partnershipId,
  };
}

export function moduleAdminPatchSuccess(partnershipId, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminPatchSuccess(${partnershipId}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_ADMIN_PATCH_SUCCESS,
    id: data.id,
    partnershipId: partnershipId,
    receivedAt: Date.now(),
  };
}

export function moduleAdminPatchFailure(partnershipId, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminPatchFailure(${partnershipId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_ADMIN_PATCH_FAILURE,
    partnershipId: partnershipId,
    error: error,
  };
}

export function moduleIdsAdminRequest(partnershipId, order) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleIdsAdminRequest(${partnershipId},  ${order})`
  );
  return {
    type: TYPES.MODULE_ADMIN_IDS_REQUEST,
    partnershipId: partnershipId,
    order: order,
  };
}

export function moduleIdsAdminSuccess(partnershipId, order, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieIdsAdminSuccess(${partnershipId}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_ADMIN_IDS_SUCCESS,
    data: data,
    partnershipId: partnershipId,
    order: order,
  };
}

export function moduleIdsAdminFailure(partnershipId, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieIdsAdminFailure(${partnershipId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_ADMIN_IDS_FAILURE,
    error: error,
    partnershipId: partnershipId,
  };
}

export function moduleAdminDeleteRequest(partnershipId, id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminDeleteRequest(${partnershipId},  ${id})`
  );
  return {
    type: TYPES.MODULE_ADMIN_DELETE_REQUEST,
    id: id,
    partnershipId: partnershipId,
  };
}

export function moduleAdminDeleteSuccess(partnershipId, moduleSerieId, id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminDeleteSuccess(${partnershipId}, ${id})`
  );
  return {
    type: TYPES.MODULE_ADMIN_DELETE_SUCCESS,
    id: id,
    partnershipId: partnershipId,
    receivedAt: Date.now(),
  };
}

export function moduleAdminDeleteFailure(partnershipId, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminDeleteFailure(${partnershipId},  %j)`,
    error
  );
  return {
    type: TYPES.MODULE_ADMIN_DELETE_FAILURE,
    error: error,
    partnershipId: partnershipId,
  };
}

export function moduleAdminDeletesRequest(partnershipId, id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminDeletesRequest(${partnershipId}, ${id})`
  );
  return {
    type: TYPES.MODULE_ADMIN_DELETES_REQUEST,
    id: id,
    partnershipId: partnershipId,
  };
}

export function moduleAdminDeletesSuccess(partnershipId, id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminDeletesSuccess(${partnershipId}, ${id})`
  );
  return {
    type: TYPES.MODULE_ADMIN_DELETES_SUCCESS,
    id: id,
    partnershipId: partnershipId,
    receivedAt: Date.now(),
  };
}

export function moduleAdminDeletesFailure(partnershipId, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleSerieAdminDeletesFailure(${partnershipId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_ADMIN_DELETES_FAILURE,
    partnershipId: partnershipId,
    error: error,
  };
}

export function moduleCategoryAdminListRequest(
  partnershipId,
  page,
  limit,
  order,
  filter
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleCategoryAdminListRequest(${partnershipId}, ${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: TYPES.MODULE_CATEGORY_ADMIN_LIST_REQUEST,
    partnershipId: partnershipId,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function moduleCategoryAdminListSuccess(partnershipId, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleCategoryAdminListSuccess(${partnershipId},  %j)`,
    data
  );
  return {
    type: TYPES.MODULE_CATEGORY_ADMIN_LIST_SUCCESS,
    partnershipId: partnershipId,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function moduleCategoryAdminListFailure(partnershipId, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleCategoryAdminListFailure(${partnershipId}, %j)`,
    error
  );
  return {
    type: TYPES.MODULE_CATEGORY_ADMIN_LIST_FAILURE,
    partnershipId: partnershipId,
    error: error,
  };
}

export function modulesAdminCreateRequest(partnershipId, moduleSerieId, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] modulesAdminCreateRequest(${partnershipId}, ${moduleSerieId}, %j)`,
    data
  );
  return {
    partnershipId,
    moduleSerieId,
    type: TYPES.MODULES_ADMIN_CREATE_REQUEST,
  };
}

export function modulesAdminCreateSuccess(partnershipId, moduleSerieId, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] modulesAdminCreateSuccess(${partnershipId}, ${moduleSerieId}, %j)`,
    data
  );
  return {
    type: TYPES.MODULES_ADMIN_CREATE_SUCCESS,
    id: data.id,
    partnershipId,
    moduleSerieId,
    receivedAt: Date.now(),
  };
}

export function modulesAdminCreateFailure(partnershipId, moduleSerieId, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] modulesAdminCreateFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULES_ADMIN_CREATE_FAILURE,
    error: error,
    partnershipId,
    moduleSerieId,
  };
}

export function modulesAdminUpdateRequest(partnershipId, moduleSerieId, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] modulesAdminUpdateRequest(${partnershipId}, ${moduleSerieId}, %j)`,
    data
  );
  return {
    partnershipId,
    moduleSerieId,
    type: TYPES.MODULES_ADMIN_UPDATE_REQUEST,
  };
}

export function modulesAdminUpdateSuccess(partnershipId, moduleSerieId, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] modulesAdminUpdateSuccess(${partnershipId}, ${moduleSerieId}, %j)`,
    data
  );
  return {
    type: TYPES.MODULES_ADMIN_UPDATE_SUCCESS,
    id: data.id,
    partnershipId,
    moduleSerieId,
    receivedAt: Date.now(),
  };
}

export function modulesAdminUpdateFailure(partnershipId, moduleSerieId, error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] modulesAdminUpdateFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULES_ADMIN_UPDATE_FAILURE,
    error: error,
    partnershipId,
    moduleSerieId,
  };
}

export function moduleAdminCreateRequest(data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminCreateRequest(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_ADMIN_CREATE_REQUEST,
  };
}

export function moduleAdminCreateSuccess(data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminCreateSuccess(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_ADMIN_CREATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function moduleAdminCreateFailure(error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminCreateFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_ADMIN_CREATE_FAILURE,
    error: error,
  };
}

export function moduleAdminReadRequest(id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminReadRequest(${id})`
  );
  return {
    type: TYPES.MODULE_ADMIN_READ_REQUEST,
    id: id,
  };
}

export function moduleAdminReadSuccess(data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminReadSuccess(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_ADMIN_READ_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function moduleAdminReadFailure(error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminReadFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_ADMIN_READ_FAILURE,
    error: error,
  };
}

export function moduleAdminUpdateRequest(id, data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminUpdateRequest(${id}, %j)`,
    data
  );
  return {
    type: TYPES.MODULE_ADMIN_UPDATE_REQUEST,
  };
}

export function moduleAdminUpdateSuccess(data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminUpdateSuccess(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_ADMIN_UPDATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function moduleAdminUpdateFailure(error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleAdminUpdateFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_ADMIN_UPDATE_FAILURE,
    error: error,
  };
}

export function moduleCategoryAdminCreateRequest(data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleCategoryAdminCreateRequest(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_CATEGORY_ADMIN_CREATE_REQUEST,
  };
}

export function moduleCategoryAdminCreateSuccess(data) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleCategoryAdminCreateSuccess(%j)`,
    data
  );
  return {
    type: TYPES.MODULE_CATEGORY_ADMIN_CREATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function moduleCategoryAdminCreateFailure(error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleCategoryAdminCreateFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_CATEGORY_ADMIN_CREATE_FAILURE,
    error: error,
  };
}

export function moduleCategoryAdminDeleteRequest(id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleCategoryAdminDeleteRequest(${id})`
  );
  return {
    type: TYPES.MODULE_CATEGORY_ADMIN_DELETE_REQUEST,
    id: id,
  };
}

export function moduleCategoryAdminDeleteSuccess(id) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleCategoryAdminDeleteSuccess(${id})`
  );
  return {
    type: TYPES.MODULE_CATEGORY_ADMIN_DELETE_SUCCESS,
    id: id,
    receivedAt: Date.now(),
  };
}

export function moduleCategoryAdminDeleteFailure(error) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] moduleCategoryAdminDeleteFailure(%j)`,
    error
  );
  return {
    type: TYPES.MODULE_CATEGORY_ADMIN_DELETE_FAILURE,
    error: error,
  };
}

export function loadModuleSeriesAdmin(
  partnershipId = null,
  action,
  filter = null,
  page = 1,
  limit = 10,
  order = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] loadModuleSeriesAdmin(${partnershipId}, ${action}, ${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(
      moduleSerieAdminListRequest(
        partnershipId,
        action,
        page,
        limit,
        order,
        filter
      )
    );

    // call API
    const response = await api.getModuleSeriesAdmin(
      partnershipId,
      page,
      limit,
      order,
      filter
    );
    let success = false;
    let result = [];
    let total = 0;

    // get module series admin list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module series admin list success. Partnership ID: ${partnershipId}, Action: ${action}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      total = response.getIn(['data', 'total']);

      const normalizedEntities = normalize(
        response.getIn(['data', 'module_series']),
        [schema.learningModuleSerieAdmin]
      );
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleSerieAdminListSuccess(partnershipId, action, data));

      result = normalizedEntities.result;
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module series admin success [empty]. Partnership ID: ${partnershipId}, Action: ${action}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(moduleSerieAdminListSuccess(partnershipId, action, data));
      success = true;

      // get module series admin list failure
    } else {
      Logger.log(
        'info',
        `Get API module series admin list failure. Partnership ID: ${partnershipId}, Action: ${action}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(
        moduleSerieAdminListFailure(
          partnershipId,
          action,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success, total, result);
  };
}

export function createModuleSerieAdmin(data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] createModuleSerieAdmin(%j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleSerieAdminCreateRequest(data));

    // call API
    const response = await api.postModuleSerieAdmin(data);
    let success = false;

    // post module serie admin success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API module serie admin success. Post: ${response.getIn([
          'data',
          'module_serie',
          'id',
        ])}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module_serie'])],
        [schema.learningModuleSerieAdmin]
      );
      const data = {
        id: response.getIn(['data', 'module_serie', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleSerieAdminCreateSuccess(data));
      success = true;

      // get module serie admin failure
    } else {
      Logger.log('info', `POST API module serie admin failure.`);
      dispatch(
        moduleSerieAdminCreateFailure(response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

export function updateModuleSerieAdmin(id, data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] updateModuleSerieAdmin(${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleSerieAdminUpdateRequest(id, data));

    // call API
    const response = await api.putModuleSerieAdmin(id, data);
    let success = false;

    // put module serie admin success
    if (200 === response.get('status')) {
      Logger.log('info', `PUT API module serie admin success. User: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module_serie'])],
        [schema.learningModuleSerieAdmin]
      );
      const data = {
        id: response.getIn(['data', 'module_serie', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleSerieAdminUpdateSuccess(data));
      success = true;

      // get module serie admin failure
    } else {
      Logger.log('info', `PUT API module serie admin failure. ID: ${id}.`);
      dispatch(
        moduleSerieAdminUpdateFailure(response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

export function loadModuleSerieAdmin(partnershipId, id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] loadModuleSerieAdmin(${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(moduleSerieAdminReadRequest(id));

    // call API
    const response = await api.getModuleSerieAdmin(partnershipId, id);
    let success = false;

    // get module serie admin success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API module serie admin success. ID: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module_serie'])],
        [schema.learningModuleSerieAdmin]
      );
      const data = {
        id: response.getIn(['data', 'module_serie', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleSerieAdminReadSuccess(data));
      success = true;

      // get module serie admin failure
    } else {
      Logger.log('info', `Get API module serie admin failure. ID: ${id}.`);
      dispatch(moduleSerieAdminReadFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function patchModuleSerieAdmin(
  partnershipId = null,
  id,
  data,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] patchModuleSerieAdmin(${partnershipId}, ${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleSerieAdminPatchRequest(partnershipId, id, data));

    // call API
    const response = await api.patchModuleSerieAdmin(partnershipId, id, data);
    let success = false;

    // put module serie success
    if (200 === response.get('status')) {
      Logger.log('info', `PUT API module serie success. User: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module_serie'])],
        [schema.learningModuleSerieAdmin]
      );
      const data = {
        id: response.getIn(['data', 'module_serie', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleSerieAdminPatchSuccess(partnershipId, data));
      success = true;

      // get module serie failure
    } else {
      Logger.log('info', `PUT API module serie failure. ID: ${id}.`);
      dispatch(
        moduleSerieAdminPatchFailure(
          partnershipId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function loadModuleSerieIdsAdmin(
  partnershipId = null,
  filter = null,
  order,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] loadModuleSeriesAdmin(${partnershipId}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(moduleSerieIdsAdminRequest(partnershipId, order));

    // call API
    const response = await api.getModuleSerieIdsAdmin(
      partnershipId,
      filter,
      order
    );
    let success = false;

    // get module serie ids success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API module serie ids success.`);
      const data = response.getIn(['data', 'module_series']);
      dispatch(moduleSerieIdsAdminSuccess(partnershipId, order, data));
      success = true;
    }
    // get module serie ids failure
    else if (204 === response.get('status')) {
      Logger.log('info', `Get API module serie ids success.`);
      dispatch(moduleSerieIdsAdminSuccess(partnershipId, order, []));
      success = true;
      // get module serie ids failure
    } else {
      Logger.log('info', `Get API module serie ids failure.`);
      dispatch(
        moduleSerieIdsAdminFailure(
          partnershipId,
          order,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function deleteModuleSeriesAdmin(
  partnershipId,
  data,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] deleteModuleSeriesAdmin(${partnershipId}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleSerieAdminDeletesRequest(partnershipId));

    // call API
    const response = await api.deleteModuleSeriesAdmin(partnershipId, data);
    let success = false;

    // post module series admin success
    if (204 === response.get('status')) {
      Logger.log(
        'info',
        `DELETE API module series success. Partnership ID: ${partnershipId}.`
      );
      dispatch(moduleSerieAdminDeletesSuccess(partnershipId));
      success = true;

      // get module series admin failure
    } else {
      Logger.log(
        'info',
        `DELETE API module series failure. Partnership ID: ${partnershipId}.`
      );
      dispatch(
        moduleSerieAdminDeletesFailure(response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

export function deleteModuleSerieAdmin(partnershipId, id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] deleteModuleSerieAdmin(${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(moduleSerieAdminDeleteRequest(id));

    // call API
    const response = await api.deleteModuleSerieAdmin(partnershipId, id);
    let success = false;

    // delete module serie success
    if (204 === response.get('status')) {
      Logger.log(
        'info',
        `DELETE API module serie success. Partnership ID: ${partnershipId}, ID: ${id}.`
      );

      dispatch(
        removeEntity({ entityType: 'learningModuleSeriesAdmin', id: id })
      );
      dispatch(moduleSerieAdminDeleteSuccess(id));
      success = true;

      // get module serie failure
    } else {
      Logger.log(
        'info',
        `DELETE API module serie failure. Partnership ID: ${partnershipId}, ID: ${id}.`
      );
      dispatch(
        moduleSerieAdminDeleteFailure(response.getIn(['data', 'error']))
      );
    }
    // callback function
    cb(success);
  };
}

export function loadModulesAdminByModuleSerieId(
  partnershipId = null,
  moduleSerieId = null,
  filter = null,
  page = 1,
  limit = 10,
  order = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] loadModulesAdminByModuleSerieId(${partnershipId}, ${moduleSerieId}, ${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(
      moduleAdminListByModuleSerieIdRequest(
        partnershipId,
        moduleSerieId,
        page,
        limit,
        order,
        filter
      )
    );

    // call API
    const response = await api.getModulesAdminByModuleSerieId(
      partnershipId,
      moduleSerieId,
      page,
      limit,
      order,
      filter
    );
    let success = false;
    let result = [];
    let total = 0;

    // get modules admin list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API modules admin list success. Partnership ID: ${partnershipId}, Module Serie ID: ${moduleSerieId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      total = response.getIn(['data', 'total']);

      const normalizedEntities = normalize(
        response.getIn(['data', 'modules']),
        [schema.learningModuleAdmin]
      );

      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(
        moduleAdminListByModuleSerieIdSuccess(
          partnershipId,
          moduleSerieId,
          data
        )
      );

      result = normalizedEntities.result;
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API modules admin success [empty]. Partnership ID: ${partnershipId}, Module Serie ID: ${moduleSerieId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(
        moduleAdminListByModuleSerieIdSuccess(
          partnershipId,
          moduleSerieId,
          data
        )
      );
      success = true;

      // get modules admin list failure
    } else {
      Logger.log(
        'info',
        `Get API modules admin list failure. Partnership ID: ${partnershipId}, Module Serie ID: ${moduleSerieId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(
        moduleAdminListByModuleSerieIdFailure(
          partnershipId,
          moduleSerieId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success, total, result);
  };
}

export function loadModulesAdmin(
  partnershipId = null,
  filter = null,
  page = 1,
  limit = 10,
  order = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] loadModulesAdmin(${partnershipId}, ${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(moduleAdminListRequest(partnershipId, page, limit, order, filter));

    // call API
    const response = await api.getModulesAdmin(
      partnershipId,
      page,
      limit,
      order,
      filter
    );
    let success = false;
    let result = [];
    let total = 0;

    // get modules admin list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API modules admin list success. Partnership ID: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      total = response.getIn(['data', 'total']);

      const normalizedEntities = normalize(
        response.getIn(['data', 'modules']),
        [schema.learningModuleAdmin]
      );

      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleAdminListSuccess(partnershipId, data));

      result = normalizedEntities.result;
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API modules admin success [empty]. Partnership ID: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(moduleAdminListSuccess(partnershipId, data));
      success = true;

      // get modules admin list failure
    } else {
      Logger.log(
        'info',
        `Get API modules admin list failure. Partnership ID: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(
        moduleAdminListFailure(partnershipId, response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success, total, result);
  };
}

export function patchModuleAdmin(
  partnershipId = null,
  id,
  data,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] patchModuleAdmin(${partnershipId}, ${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleAdminPatchRequest(partnershipId, id, data));

    // call API
    const response = await api.patchModuleAdmin(partnershipId, id, data);
    let success = false;

    // put module success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `PUT API module success. Partnership ID: ${partnershipId}, Module ID: ${id}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module'])],
        [schema.learningModuleAdmin]
      );
      const data = {
        id: response.getIn(['data', 'module', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleAdminPatchSuccess(partnershipId, data));
      success = true;

      // get module failure
    } else {
      Logger.log(
        'info',
        `PUT API module failure. Partnership ID: ${partnershipId},  Module ID: ${id}.`
      );
      dispatch(
        moduleAdminPatchFailure(
          partnershipId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function loadModuleIdsAdmin(
  partnershipId = null,
  filter = null,
  order,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] loadModuleIdsAdmin(${partnershipId}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(moduleIdsAdminRequest(partnershipId, order));

    // call API
    const response = await api.getModuleIdsAdmin(partnershipId, filter, order);

    let success = false;

    // get module ids success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API module ids success.`);
      const data = response.getIn(['data', 'modules']);
      dispatch(moduleIdsAdminSuccess(partnershipId, order, data));
      success = true;
    }
    // get module ids failure
    else if (204 === response.get('status')) {
      Logger.log('info', `Get API module ids success.`);
      dispatch(moduleIdsAdminSuccess(partnershipId, order, []));
      success = true;
      // get module ids failure
    } else {
      Logger.log('info', `Get API module ids failure.`);
      dispatch(
        moduleIdsAdminFailure(
          partnershipId,
          order,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function deleteModulesAdmin(partnershipId, data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] deleteModulesAdmin(${partnershipId}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleAdminDeletesRequest(partnershipId));

    // call API
    const response = await api.deleteModulesAdmin(partnershipId, data);
    let success = false;

    // post module admin success
    if (204 === response.get('status')) {
      Logger.log(
        'info',
        `DELETE API module success. Partnership ID: ${partnershipId}`
      );
      dispatch(moduleAdminDeletesSuccess(partnershipId));
      success = true;

      // get module admin failure
    } else {
      Logger.log(
        'info',
        `DELETE API module failure. Partnership ID: ${partnershipId}`
      );
      dispatch(
        moduleAdminDeletesFailure(
          partnershipId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function deleteModuleAdmin(partnershipId, id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] deleteModuleAdmin(${partnershipId},  ${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(moduleAdminDeleteRequest(partnershipId, id));

    // call API
    const response = await api.deleteModuleAdmin(partnershipId, id);
    let success = false;

    // delete module success
    if (204 === response.get('status')) {
      Logger.log(
        'info',
        `DELETE API module success. Partnership ID: ${partnershipId},  Module ID: ${id}.`
      );

      dispatch(removeEntity({ entityType: 'learningModulesAdmin', id: id }));
      dispatch(moduleAdminDeleteSuccess(partnershipId, id));
      success = true;

      // get module failure
    } else {
      Logger.log(
        'info',
        `DELETE API module failure. Partnership ID: ${partnershipId},  Module ID: ${id}.`
      );
      dispatch(moduleAdminDeleteFailure(partnershipId, id, response));
    }
    // callback function
    cb(success);
  };
}

export function loadModuleCategoriesAdmin(
  partnershipId = null,
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] loadModuleCategoriesAdmin(${partnershipId}, ${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(
      moduleCategoryAdminListRequest(partnershipId, page, limit, order, filter)
    );

    // call API
    const response = await api.getModuleCategoriesAdmin(
      partnershipId,
      page,
      limit,
      order,
      filter
    );
    let success = false;
    let result = [];
    let total = 0;

    // get module series admin list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module series admin list success. Partnership ID: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      total = response.getIn(['data', 'total']);

      const normalizedEntities = normalize(
        response.getIn(['data', 'module_categories']),
        [schema.learningModuleCategoryAdmin]
      );
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleCategoryAdminListSuccess(partnershipId, data));

      result = normalizedEntities.result;
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API module series admin success [empty]. Partnership ID: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(moduleCategoryAdminListSuccess(partnershipId, data));
      success = true;

      // get module series admin list failure
    } else {
      Logger.log(
        'info',
        `Get API module series admin list failure. Partnership ID: ${partnershipId},  Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(
        moduleCategoryAdminListFailure(
          partnershipId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success, total, result);
  };
}

export function createModulesAdmin(
  partnershipId,
  moduleSerieId,
  data,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] createModulesAdmin(%j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(modulesAdminCreateRequest(partnershipId, moduleSerieId, data));

    // call API
    const response = await api.postModulesAdmin(
      partnershipId,
      moduleSerieId,
      data
    );
    let success = false;

    // post modules admin success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API modules admin success. Post: ${response.getIn([
          'data',
          'module_serie',
          'id',
        ])}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module_serie'])],
        [schema.learningModuleSerieAdmin]
      );
      const data = {
        id: response.getIn(['data', 'module_serie', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(modulesAdminCreateSuccess(partnershipId, moduleSerieId, data));
      success = true;

      // get modules admin failure
    } else {
      Logger.log('info', `POST API modules admin failure.`);
      dispatch(
        modulesAdminCreateFailure(
          partnershipId,
          moduleSerieId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function updateModulesAdmin(
  partnershipId,
  moduleSerieId,
  data,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] updateModulesAdmin(%j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(modulesAdminUpdateRequest(partnershipId, moduleSerieId, data));

    // call API
    const response = await api.putModulesAdmin(
      partnershipId,
      moduleSerieId,
      data
    );
    let success = false;

    // put modules admin success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `PUT API modules admin success. Post: ${response.getIn([
          'data',
          'module_serie',
          'id',
        ])}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module_serie'])],
        [schema.learningModuleSerieAdmin]
      );
      const data = {
        id: response.getIn(['data', 'module_serie', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(modulesAdminUpdateSuccess(partnershipId, moduleSerieId, data));
      success = true;

      // get modules admin failure
    } else {
      Logger.log('info', `PUT API modules admin failure.`);
      dispatch(
        modulesAdminUpdateFailure(
          partnershipId,
          moduleSerieId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function createModuleAdmin(data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] createModuleAdmin(%j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleAdminCreateRequest(data));

    // call API
    const response = await api.postModuleAdmin(data);
    let success = false;

    // post module admin success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API module admin success. Post: ${response.getIn([
          'data',
          'module',
          'id',
        ])}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module'])],
        [schema.learningModuleAdmin]
      );
      const data = {
        id: response.getIn(['data', 'module', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleAdminCreateSuccess(data));
      success = true;

      // get module admin failure
    } else {
      Logger.log('info', `POST API module admin failure.`);
      dispatch(moduleAdminCreateFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function loadModuleAdmin(partnershipId, id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] loadModuleAdmin(${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(moduleAdminReadRequest(id));

    // call API
    const response = await api.getModuleAdmin(partnershipId, id);
    let success = false;
    // get module admin success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API module admin success. ID: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module'])],
        [schema.learningModuleAdmin]
      );
      const data = {
        id: response.getIn(['data', 'module', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleAdminReadSuccess(data));
      success = true;

      // get module admin failure
    } else {
      Logger.log('info', `Get API module admin failure. ID: ${id}.`);
      dispatch(moduleAdminReadFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function updateModuleAdmin(id, data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] updateModuleAdmin(${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleAdminUpdateRequest(id, data));

    // call API
    const response = await api.putModuleAdmin(id, data);
    let success = false;

    // put module admin success
    if (200 === response.get('status')) {
      Logger.log('info', `PUT API module admin success. User: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module'])],
        [schema.learningModuleAdmin]
      );
      const data = {
        id: response.getIn(['data', 'module', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleAdminUpdateSuccess(data));
      success = true;

      // get module admin failure
    } else {
      Logger.log('info', `PUT API module admin failure. ID: ${id}.`);
      dispatch(moduleAdminUpdateFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function createModuleCategoryAdmin(data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] createModuleCategoryAdmin(%j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(moduleCategoryAdminCreateRequest(data));

    // call API
    const response = await api.postModuleCategoryAdmin(data);
    let success = false;
    let id = null;
    // post module category admin success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API module category admin success. Post: ${response.getIn([
          'data',
          'module_category',
          'id',
        ])}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'module_category'])],
        [schema.learningModuleCategoryAdmin]
      );
      id = response.getIn(['data', 'module_category', 'id']);
      const data = {
        id,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(moduleCategoryAdminCreateSuccess(data));
      success = true;

      // get module category admin failure
    } else {
      Logger.log('info', `POST API module category admin failure.`);
      dispatch(
        moduleCategoryAdminCreateFailure(response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success, id);
  };
}

export function deleteModuleCategoryAdmin(
  partnershipId,
  id,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.actions] deleteModuleCategoryAdmin(${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(moduleCategoryAdminDeleteRequest(id));

    // call API
    const response = await api.deleteModuleCategoryAdmin(partnershipId, id);
    let success = false;

    // delete module category success
    if (204 === response.get('status')) {
      Logger.log(
        'info',
        `DELETE API module category success. Partnership ID: ${partnershipId}, ID: ${id}.`
      );

      dispatch(
        removeEntity({ entityType: 'learningModuleCategoriesAdmin', id: id })
      );

      dispatch(moduleCategoryAdminDeleteSuccess(id));
      success = true;

      // get module category failure
    } else {
      Logger.log(
        'info',
        `DELETE API module category failure. Partnership ID: ${partnershipId}, ID: ${id}.`
      );
      dispatch(
        moduleCategoryAdminDeleteFailure(response.getIn(['data', 'error']))
      );
    }
    // callback function
    cb(success);
  };
}
